import { Box, Stack } from '@mui/material'
import React from 'react'
import { TimelineTeamControlAdd } from '../TimelineTeamControlAdd/TimelineTeamControlAdd'
import { TimelineTeamControlRemove } from '../TimelineTeamControlRemove/TimelineTeamControlRemove'
import { TimelineTeamControlSelect } from '../TimelineTeamControlSelect/TimelineTeamControlSelect'
import { TimelineTeamMemberControlAdd } from '../TimelineTeamMemberControlAdd/TimelineTeamMemberControlAdd'
import { TimelineTeamMembers } from '../TimelineTeamMembers/TimelineTeamMembers'
import * as Styled from './TimelineTraineeMembersTab.styled'

export function TimelineTraineeMembersTab() {
  return (
    <Stack paddingLeft={{ xs: 2 }} paddingRight={1} spacing={2}>
      <Stack direction="row" justifyContent="flex-end" mt={2} mr={2} mb={1}>
        <TimelineTeamControlAdd />
      </Stack>

      <Styled.TeamControlsContainer>
        <TimelineTeamControlSelect />

        <Styled.TeamControls>
          <TimelineTeamMemberControlAdd />
          <TimelineTeamControlRemove />
        </Styled.TeamControls>
      </Styled.TeamControlsContainer>

      <Box sx={{ marginBottom: '80px' }}>
        <TimelineTeamMembers />
      </Box>
    </Stack>
  )
}
